import { render, staticRenderFns } from "./role-modal.vue?vue&type=template&id=70302630&scoped=true"
import script from "./role-modal.vue?vue&type=script&lang=js"
export * from "./role-modal.vue?vue&type=script&lang=js"
import style0 from "./role-modal.vue?vue&type=style&index=0&id=70302630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70302630",
  null
  
)

export default component.exports